import { Image } from './model';

export interface DetailsImagesState {
  readonly images: Image[];
  readonly requestState: ImagesUIState;
}

export enum ImagesUIState {
  NotSetYet = 0,
  Downloaded = 100,
  DownloadFail = 101,
  Uploaded = 102,
  UploadFail = 103,
  Deleted = 104,
  DeleteFail = 105,
  Downloading = 200,
  Uploading = 201,
  Deleting = 202,
  HasOfflineImagesForUpload = 300
}

export const enum DetailsImagesActionTypes {
  FETCH_IMAGES = '@@detailsImages/FETCH_IMAGES',
  FETCH_IMAGES_FAIL = '@@detailsImages/FETCH_IMAGES_FAIL',
  FETCH_IMAGES_SUCCESS = '@@detailsImages/FETCH_IMAGES_SUCCESS',
  UPLOAD_IMAGES = '@@detailsImage/UPLOAD_IMAGES',
  UPLOAD_IMAGES_FAIL = '@@detailsImages/UPLOAD_IMAGES_FAIL',
  UPLOAD_IMAGES_SUCCESS = '@@detailsImages/UPLOAD_IMAGES_SUCCESS',
  DELETE_IMAGES = '@@detailsImage/DELETE_IMAGES',
  DELETE_IMAGES_FAIL = '@@detailsImages/DELETE_IMAGES_FAIL',
  DELETE_IMAGES_SUCCESS = '@@detailsImages/DELETE_IMAGES_SUCCESS',
  RESET_STATE = '@@detailsImages/RESET_STATE',
  SET_IMAGES_REQUEST_STATE = '@@detailsImages/SET_IMAGES_REQUEST_STATE',
  UPDATE_IMAGES = '@@detailsImages/UPDATE_IMAGES',
  UPDATE_IMAGES_SUCCESS = '@@detailsImages/UPDATE_IMAGES_SUCCESS',
  UPDATE_IMAGES_FAIL = '@@detailsImages/UPDATE_IMAGES_FAIL',
  REPLACE_IMAGES = '@@detailsImages/REPLACE_IMAGES',
  SET_IMAGES_IS_DIRTY = '@@detailsImages/SET_IMAGES_IS_DIRTY',
  GET_IMAGE_SRC = '@@overview/GET_IMAGE_SRC',
  GET_IMAGE_SRC_SUCCESS = '@@overview/GET_IMAGE_SRC_SUCCESS',
  GET_IMAGE_SRC_FAIL = '@@overview/GET_IMAGE_SRC_FAIL',
  IMPORT_REVIDEA_IMAGES = '@@detailsImages/IMPORT_REVIDEA_IMAGES',
  IMPORT_REVIDEA_IMAGES_SUCCESS = '@@/IMPORT_REVIDEA_IMAGES_SUCCESS',
  IMPORT_REVIDEA_IMAGES_FAIL = '@@detailsImages/IMPORT_REVIDEA_IMAGES_FAIL',
}
